import * as React from 'react';

export const ResizeBars = () => (
  <svg width={15} height={14} fill="none">
    <path transform="rotate(135.055 6.5 2.689)" stroke="#CCC" d="M0-.5h16.97" />
    <path stroke="#CCC" d="M14.085 5.329l-8 8" />
  </svg>
);
